import { isNull } from "lodash";
import moment from "moment";
import { DAILY_STAT_TABLE_DATA_START_DATE } from "../domain";

export const useDateRangeMeta = ({ fromDate, toDate }) => {
  const output = {
    from: { minDate: null, maxDate: null },
    to: { minDate: null, maxDate: null },
    useMonthlyTableStats: false,
  };

  if (isNull(fromDate) && isNull(toDate)) {
    return output;
  }

  const dailyStatStartDate = moment(DAILY_STAT_TABLE_DATA_START_DATE);

  if (!isNull(fromDate)) {
    const startDate = moment(fromDate);
    if (startDate.isBefore(dailyStatStartDate)) {
      output.to.maxDate = dailyStatStartDate
        .subtract(1, "day")
        .endOf("day")
        .format("YYYY-MM-DD");
      output.to.minDate = startDate.format("YYYY-MM-DD");
      output.useMonthlyTableStats = true;
    } else {
      output.to.minDate = startDate.format("YYYY-MM-DD");
    }
  }

  return output;
};
